import classNames from "classnames";
import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";
import Icon from "./Icon";

// The default loading spinner, which is a simple spinning notch icon centered in its
// parent container.
//
const Spinner = props => {
  const className = classNames("loading-spinner-container", props.className);
  const t = useFormatMessage();
  const loadingSrLabel = t(intlMessages.loadingSrLabel);

  return (
    <span className={className}>
      <Icon className="fa fa-circle-notch fa-spin loading-spinner" />
      <span className="sr-only">{loadingSrLabel}</span>
    </span>
  );
};

// A Spinner included in a white box with rounded borders, like most of the content of
// the app.
//
export const BoxSpinner = props => {
  const className = classNames("box-loading-spinner", props.className);

  return <Spinner className={className} />;
};

// A spinner shown over its closest relative content with a light transparent white
// overlay.
//
export const OverlaySpinner = props => {
  const className = classNames("overlay-loading-spinner", props.className);

  return <Spinner className={className} />;
};

export default Spinner;

const intlMessages = defineMessages({
  loadingSrLabel: {
    id: "spinner.loadingSrLabel",
    defaultMessage: "Chargement en cours ..."
  }
});
